import * as React from 'react';
import * as Classes from '../common/classes';
import classNames from 'classnames';
import { useInverseBg } from '../theme/useInverseBg';

type Props = {
  row?: number;
  col?: number;
  minWidthPercent?: number;
  maxWidthPercent?: number;
  inverse?: boolean;
};
export const Skeleton: React.FC<Props> = ({
  row,
  col,
  maxWidthPercent = 100,
  minWidthPercent = 25,
  inverse,
}) => {
  const rows = 1;
  const parentInverse = useInverseBg(inverse);
  let size = maxWidthPercent;
  if (row || col) {
    let urow = row || 1;
    let ucol = col || 1;
    size =
      ((urow * ucol * (urow * 3 + ucol * 5)) %
        (maxWidthPercent - minWidthPercent)) +
      minWidthPercent;
  }

  let content = [];
  for (let a = 0; a < rows; a++) {
    content.push(
      <div
        key={a}
        className={Classes.SKELETON_ITEM}
        style={{ width: `${size}%` }}
      >
        &nbsp;
      </div>
    );
  }

  return (
    <div
      className={classNames(Classes.SKELETON, {
        [Classes.SKELETON_INVERSE]: inverse || parentInverse,
      })}
    >
      {content}
    </div>
  );
};
